import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#56A6C3',
      contrastText: '#fff',
    },
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
    allVariants: {
      fontFamily: '"Inter", sans-serif',
    },
    h3: {
      fontSize: 20,
      fontWeight: 700,
    },
    h4: {
      fontSize: 15,
    },
    h5: {
      fontSize: 12,
      color: '#857F7F',
      fontWeight: 400,
    },
  },
  overrides: {
    MuiButton: {
        root: {
            textTransform: 'none'
        }
    }
},
});

export default theme;